import {ReactComponent} from '../../app'
import {Spin} from "antd"

export default class ReservationWidget extends ReactComponent {

  state = {
    loading: false
  }

  componentDidMount() {

    void this.updateState({loading: true})

    const height = Math.floor(window.innerHeight * 0.75)
    const rootStyles = getComputedStyle(document.documentElement)
    const primaryColor = rootStyles.getPropertyValue('--_primary-hex').trim()
    const secondaryColor = rootStyles.getPropertyValue('--_secondary-hex').trim()
    const fontColor = rootStyles.getPropertyValue('--_font-hex').trim()

    window._hors = [
      ['eid', this.props.eid],
      ['tagid', this.props.id],
      ['width', '100%'],
      ['height', height],
      ['foregroundColor', fontColor],
      ['backgroundColor', ''],
      ['linkColor', ''],
      ['errorColor', ''],
      ['primaryButtonForegroundColor', primaryColor],
      ['primaryButtonBackgroundColor', secondaryColor],
      ['secondaryButtonForegroundColor', ''],
      ['secondaryButtonBackgroundColor', ''],
    ];

    (function (d, t) {
      var e = d.createElement(t), s = d.getElementsByTagName(t)[0]
      e.src = 'https://reservation.dish.co/widget.js'
      e.id = 'dish-widget-script'
      s.parentNode.insertBefore(e, s)
    }(document, 'script'))

    setTimeout(() => {
      void this.updateState({loading: false})
    },1000)
  }

  componentWillUnmount() {

    document.getElementById('dish-widget-script').remove()

  }

  render() {
    return (
      <Spin spinning={this.state.loading} size="large">
        <div id={this.props.id}></div>
      </Spin>
    )
  }
}